import { useTranslation } from "react-i18next";

export function EndingCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-primary/10" />
      <div className="container mx-auto text-center relative z-10">
        <div className="mb-8" style={{ opacity: 1 }}>
          <div style={{ transform: "translateY(-3.36162px)" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={1}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-chevron-down w-16 h-16 text-foreground mx-auto"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={1}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-chevron-down w-16 h-16 text-foreground mx-auto -mt-8"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </div>
        </div>
        <div className="mb-6 select-none" style={{ opacity: 1, transform: "none" }}>
          <span className="badge-purple">{t("landingPage.endingCta.badge")}</span>
        </div>
        <h2
          className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 select-none"
          style={{ opacity: 1, transform: "none" }}
        >
          {t("landingPage.endingCta.title")}
        </h2>
        <p
          className="text-lg text-muted-foreground mb-10 max-w-2xl mx-auto select-none"
          style={{ opacity: 1, transform: "none" }}
        >
          {t("landingPage.endingCta.description")}
        </p>
        <div
          style={{ opacity: 1, transform: "none" }}
          className="hidden md:block"
        >
          <a href="/book-a-call" className="btn-primary-glow select-none">
            <span>{t("landingPage.endingCta.button")}</span>
            <span className="btn-arrow-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-arrow-right w-4 h-4 arrow-right"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-arrow-right w-4 h-4 arrow-left"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
